import React from 'react';
import ConfirmationDialogPage from '@pages-clean/dummy-page/pages/confirmation-dialog-page';
import DialogWithInputsPage from '@pages-clean/dummy-page/pages/dialog-with-inputs-page';
import DraggableDialogPage from '@pages-clean/dummy-page/pages/draggable-dialog-page';
import DraggableDialogSteppedPage from '@pages-clean/dummy-page/pages/draggable-dialog-stepped-page';
import DraggableDialogWithInputsPage from '@pages-clean/dummy-page/pages/draggable-dialog-with-inputs-page';
import ToastNotificationsPage from '@pages-clean/dummy-page/pages/toast-notifications-page';

const DialogsPage = () => {
    return (
        <div
            style={{
                width: 3840,
                height: 2160,
            }}
        >
            <fieldset>
                <legend>Note</legend>
                <div className="k-d-flex k-gap-4 k-py-2">
                    The horizontal and vertical scrolls are added for testing purposes
                </div>
            </fieldset>
            <h2>Confirmation and Warnings</h2>
            <ConfirmationDialogPage />
            <br />
            <h2>Draggable Dialog</h2>
            <DraggableDialogPage />
            <br />
            <h2>Stepped Draggable Dialog</h2>
            <DraggableDialogSteppedPage />
            <br />
            <h2>Dialog with input fields</h2>
            <DialogWithInputsPage />
            <br />
            <h2>Draggable Dialog with input fields</h2>
            <DraggableDialogWithInputsPage />
            <br />
            <h2>Toast Notifications</h2>
            <ToastNotificationsPage />
        </div>
    );
};

export default DialogsPage;
